function validateForm() {
    (function () {
        'use strict'

        let forms = document.querySelectorAll('.needs-validation')

        Array.from(forms).forEach(form => {
            form.addEventListener('submit', event => {
                if (!form.checkValidity()) {
                    event.preventDefault()
                    event.stopPropagation()
                } else {
                    let loader = document.querySelector('.loader_form');
                    form.querySelector('.loader_form ').style.display = 'block';
                }

                form.classList.add('was-validated')
            }, false)
        })

        let number_only = document.querySelector('.number_only');

        if ( number_only ) {
            number_only.addEventListener('keypress', function (event) {
                let keycode = event.which;
                if (!(event.shiftKey == false && (keycode == 46 || keycode == 8 || keycode == 37 || keycode == 39 || (keycode >= 48 && keycode <= 57)))) {
                    event.preventDefault();
                }
            });
        }

    })()
}

export { validateForm }